import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from 'react-i18next';
import i18n from './i18n'


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    minWidth: 275,
  },
  pos: {
    marginBottom: 12,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
}));

export const Contact = () => {
  const classes = useStyles();
  const bull = <span className={classes.bullet}>•</span>;
  const {t, i18n} = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div>
      <Grid container>
      <Card className={classes.root} variant="outlined" textAlign="center">
      <CardContent>
        <Typography component="h2"　variant="h5">
        {t('Contact')}
        </Typography>
        <br/>
        <Card className={classes.root} variant="outlined" textAlign="center">
        <CardContent>
        <Typography variant="h10" >
        {t('Developer')} : Yoshihiro Tamai
        </Typography>
        <br/>
        <Typography variant="h10" >
        {t('E-mail')} : osmanthus0010@gmail.com
        </Typography>
        <br/>
        <Typography variant="h10" >
        <a href="https://twitter.com/osmanthus0010" target="_blank" rel="noopener noreferrer">Twitter</a>
        </Typography>
        </CardContent>
        </Card>
      </CardContent>
    </Card>
      </Grid>
    </div>
  )
}
